import { Link } from 'react-router-dom';

export default function PageHeader({ title, description }) {
    return (
        <div className="s-service-area pt-165">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-11">
                        <div className="s-service-content">
                            <div className="title" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                                <h1>{title}</h1>
                            </div>
                            <div
                                className="description pro-description"
                                data-aos="fade-up"
                                data-aos-delay={400}
                                data-aos-duration={1000}
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                            <a href="#" className="scroll-down  pro-scroll-down">
                                <span>SCROLL</span>
                                <img src="/assets/img/icons/arrow-down.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
